<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="details-container">
    @if (!(loadingPolicies$ | async)) {
        <form [formGroup]="form">
            <div class="form-container">
                <div class="form-element">
                    <mat-form-field appearance="outline" class="group-form-field" subscriptSizing="dynamic">
                        <mat-label>{{ 'groups.forms.group-name' | translate }}</mat-label>
                        <input matInput formControlName="name" (change)="emitChanges()"/>
                        <mat-error *ngIf="form.controls.name?.errors?.exists">{{ 'groups.name-exists' | translate }}</mat-error>
                        <mat-error *ngIf="form.controls.name?.errors?.required">{{ 'groups.name-required' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                <div class="form-element">
                    <mat-form-field appearance="outline" class="group-form-field" subscriptSizing="dynamic">
                        <mat-label>{{ 'groups.forms.group-description' | translate }}</mat-label>
                        <input matInput formControlName="description" (change)="emitChanges()"/>
                    </mat-form-field>
                </div>
                <div class="form-element">
                    <mat-form-field appearance="outline" class="group-form-field" subscriptSizing="dynamic">
                        <mat-label>{{ 'GA_POLICY' | translate }}</mat-label>
                        <mat-select formControlName="policy" (selectionChange)="emitChanges()">
                            <mat-option *ngFor="let policy of policies" [value]="policy.id">{{ policy.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </form>
    } @else {
        <ngx-skeleton-loader appearance="line" [theme]="formSkeletonTheme" count="3"></ngx-skeleton-loader>
    }
    <hr />
    <div class="table-container">
        <div class="device-table-header table-header">
            <div class="search-input-wrapper">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'DSS_SEARCH' | translate }}</mat-label>
                    <input matInput [(ngModel)]="search" appDebounceInput (debounceInput)="getDevices()"
                           [debounceTime]="250" type="search">
                </mat-form-field>
            </div>
        </div>
        <div class="table-wrapper">
            <table mat-table [dataSource]="(loadingDevices$ | async) ? loadingSkeletonRows : dataSource"
                   [trackBy]="trackById"
                   matSortDisableClear='true'
                   matSortActive="createdDate" matSortStart="desc" matSortDirection="desc"
                   (matSortChange)="sortColumn($event)" matSort class="mat-elevation-z0"
                   aria-describedby="Select Endpoints to assign to the group">

                <ng-container matColumnDef="select">
                    <th scope="col" mat-header-cell *matHeaderCellDef class="checkbox-cell">
                        <mat-checkbox (click)="$event.stopPropagation()"
                                      (change)="toggleAll()"
                                      [checked]="selection.hasValue() && isAllSelected()"
                                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                                      [disabled]="(loadingDevices$ | async) || isDefaultGroup() || isAllDisabled()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let device" class="checkbox-cell">
                        <span [matTooltipDisabled]="device.device_set_id === groupSettings.groupId || device.device_set_id === -1"
                              [matTooltip]="getGroupTooltip(device)"  matTooltipPosition="right">
                          <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="toggleRow($event.checked, device)"
                                        [checked]="selection.isSelected(device)"
                                        [disabled]="(loadingDevices$ | async) || (!selection.isSelected(device) && device.device_set_id !== groupSettings.groupId && device.device_set_id !== -1) || isDefaultGroup()">
                          </mat-checkbox>
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 138px;">
                        {{ 'NAME' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let device">
                        <ng-container *ngIf="(loadingDevices$ | async); else endpointNameLoaded">
                            <ngx-skeleton-loader appearance="line" [theme]="{ height: '17px' }"></ngx-skeleton-loader>
                        </ng-container>
                        <ng-template #endpointNameLoaded>
                            @if (device.deactivated == 0) {
                                <span>
                                  <a [routerLink]="['/endpoints']" [queryParams]="{endpoints_target:'inventory'}">
                                    {{ device.computer_name || '...' }}
                                  </a>
                                </span>
                            } @else {
                                <span class="deactivated-device-name">
                                    <span>
                                      <a [routerLink]="['/endpoints']" [queryParams]="{endpoints_target:'inventory'}">
                                        {{ device.computer_name || '...' }}
                                      </a>
                                    </span>
                                    <span>({{ 'DEACTIVATED' | translate }})</span>
                                </span>
                            }
                        </ng-template>
                    </td>
                </ng-container>

              <ng-container matColumnDef="group">
                  <th scope="col" mat-header-cell *matHeaderCellDef style="min-width: 123px;">
                      {{'END_GROUP' | translate}}
                  </th>
                  <td mat-cell *matCellDef="let device" id="endpoint-group">
                    <ng-container *ngIf="(loadingDevices$ | async); else groupLoaded">
                        <ngx-skeleton-loader appearance="line" [theme]="{ height: '17px' }"></ngx-skeleton-loader>
                    </ng-container>
                    <ng-template #groupLoaded>
                        @if (device.device_set_id !== -1) {
                          <a [routerLink]="['/', 'group-details', 'device', device.device_set_id]">
                            {{device.device_set_name}}
                          </a>
                        } @else {
                          {{device.device_set_name}}
                        }
                    </ng-template>
                  </td>
              </ng-container>

              <ng-container matColumnDef="policy">
                  <th scope="col" mat-header-cell *matHeaderCellDef style="min-width: 138px;">
                      {{'END_POLICY' | translate}}
                  </th>
                  <td mat-cell *matCellDef="let device" id="endpoint-policy">
                    <ng-container *ngIf="(loadingDevices$ | async); else policiesLoaded">
                        <ngx-skeleton-loader appearance="line" [theme]="{ height: '17px' }"></ngx-skeleton-loader>
                    </ng-container>
                    <ng-template #policiesLoaded>
                      @if (!selectedOrgId || selectedOrgId === 'All') {
                          <a [routerLink]="['/policy', device?.policy_id]">
                              {{device.policy_name}}
                          </a>
                      } @else {
                          <a [routerLink]="['/policy', device?.policy_id]"
                             [queryParams]="{selectedOrgId: selectedOrgId}">{{device.policy_name}}
                          </a>
                      }
                    </ng-template>
                  </td>
              </ng-container>

                <ng-container matColumnDef="os">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 176px;">
                        {{ 'END_OS' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let device">
                        <ng-container *ngIf="(loadingDevices$ | async); else osLoaded">
                            <ngx-skeleton-loader appearance="line" [theme]="{ height: '17px' }"></ngx-skeleton-loader>
                        </ng-container>
                        <ng-template #osLoaded>
                            {{ device.os }}
                        </ng-template>
                    </td>
                </ng-container>

                  <ng-container matColumnDef="createdDate">
                      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 216px;">
                          {{'IV_CREATE' | translate}}
                      </th>
                      <td mat-cell *matCellDef="let device" id="created-date">
                        <ng-container *ngIf="(loadingDevices$ | async); else createdDateLoaded">
                            <ngx-skeleton-loader appearance="line" [theme]="{ height: '17px' }"></ngx-skeleton-loader>
                        </ng-container>
                        <ng-template #createdDateLoaded>
                          {{device.created_dttm | date : 'medium'}}
                        </ng-template>
                      </td>
                  </ng-container>

                <ng-container matColumnDef="last_logged_in_user">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 153px;">
                        {{ 'END_LAST_LOGGED_IN' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let device">
                        <ng-container *ngIf="(loadingDevices$ | async); else lastLoggedInUserLoaded">
                            <ngx-skeleton-loader appearance="line" [theme]="{ height: '17px' }"></ngx-skeleton-loader>
                        </ng-container>
                        <ng-template #lastLoggedInUserLoaded>
                            {{ device.last_logged_in_user?.email }}
                        </ng-template>
                    </td>
                </ng-container>

                  <ng-container matColumnDef="lastSeen">
                      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 291px;">
                          {{'END_SEEN' | translate}}
                      </th>
                      <td mat-cell *matCellDef="let device" id="endpoint-last-seen">
                        <ng-container *ngIf="(loadingDevices$ | async); else lastSeenLoaded">
                            <ngx-skeleton-loader appearance="line" [theme]="{ height: '17px' }"></ngx-skeleton-loader>
                        </ng-container>
                        <ng-template #lastSeenLoaded>
                          {{device.last_seen}}
                        </ng-template>
                      </td>
                  </ng-container>
                <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: columns;"
                    [ngClass]="{'excluded-row': row.device_set_id !== groupSettings.groupId && row.device_set_id !== -1}">
                </tr>
            </table>
        </div>
        <mat-paginator class="device-paginator"
                       (page)="handlePageEvent($event)"
                       [pageSizeOptions]="pageSizeOptions"
                       [pageSize]="pageSize"
                       [pageIndex]="pageIndex"
                       [length]="length"
                       [showFirstLastButtons]="true">
        </mat-paginator>
    </div>
</div>
